import {
    Component,
    forwardRef,
    Input,
    Output,
    ViewChild,
    OnInit,
    EventEmitter,
    OnChanges,
    SimpleChange
} from '@angular/core';

import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

const noop = () => {
};

export const MULTIEDIT_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MultiEditComponent),
    multi: true
};

@Component({
    selector: 'itpx-multi-edit',
    templateUrl: './multi-edit.component.html',
    styleUrls: ['./multi-edit.component.css'],
    providers: [MULTIEDIT_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class MultiEditComponent implements OnInit {
    @ViewChild('editor') input;
    @ViewChild('add') add;
    @Input() url: string;
    @Input() label: string;
    @Input() regex: string = null;
    @Input() minSize: number = -1;
    @Input() maxSize: number = -1;
    @Input() emptyMessage: string;
    @Input() placeholder: string;
    @Input() maxItems: number = -1;
    @Input() data: Array<string> = [];
    @Output() change: EventEmitter<any> = new EventEmitter();

    private items: Array<string> = [];
    private invalidError: boolean = false;

    ngOnInit() {
        this.validate('');
    }

    ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
        if (changes['data']) {
            this.items = this.data || [];
            // this.items = eval(JSON.stringify(this.data)) || [];
        }
    }

    private onInputChange(event: any) {
        this.checkAndAddValue(event.keyCode == 13);
    }

    private onBlur() {
        let value = this.input.nativeElement.value;
        if (value) {
            let isValidInput = this.isValid(value);
            this.invalidError = !isValidInput;
            if (isValidInput) this.checkAndAddValue(true);
        } else {
            this.invalidError = false;
        }
    }
    private onFocus() {
        this.invalidError = false;
    }

    private checkAndAddValue(add: boolean) {
        
        let input = this.input.nativeElement;

        if (add && this.isValid(input.value)) {

            let item = input.value;
            if (!item) return;
            let index = this.items.indexOf(item, 0);
            if (index === -1) this.items.push(item);
            input.value = '';
            this.checkMaxItems();
            this.emitChange();
            input.focus();
        }

        this.validate(input.value);
    }


    private resolveRegex(regex: string) {
        if (!regex)
            return regex;

        switch (regex) {
            case 'email':
                return '[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
            default:
                return regex;
        }
    }

    private isValid(value) {
 
        let valid = true;

        if (!value)
            valid = false;

        let regex = this.resolveRegex(this.regex);
        if (regex)
            valid = valid && new RegExp(regex).test(value);

        if (this.minSize >= 0)
            valid = valid && value && value.length >= this.minSize;

        if (this.maxSize >= 0)
            valid = valid && value && value.length <= this.maxSize;

        return valid;
    }

    private validate(value) {
  
        this.add.nativeElement.disabled = !this.isValid(value);
    }

    private checkMaxItems() {
        if (this.maxItems > 0)
            this.input.nativeElement.disabled = this.items.length >= this.maxItems;
    }

    private onItemRemove(item: string) {
        let index = this.items.indexOf(item, 0);
        if (index > -1) this.items.splice(index, 1);
        this.checkMaxItems();
        this.emitChange();
    }

    private emitChange() {
        this.change.emit(this.items);
        this.onChangeCallback(this.items);
    }

    // Placeholders for the callbacks which are later providesd
    // by the Control Value Accessor
    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    // From ControlValueAccessor interface
    writeValue(value: any) {
        if (value !== this.items) {
            this.items = value || [];
        }
    }

    // From ControlValueAccessor interface
    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    // From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/multi-edit/multi-edit.component.ts